import React from 'react';
import { useI18n } from '../i18n/I18nContext';
import './TrustSection.css';

function TrustSection() {
  const { copy } = useI18n();

  return (
    <section className="michaela-trust-section" aria-label={copy.home.profileAria}>
      <div className="michaela-trust-inner">
        <div className="michaela-trust-profile">
          <h2 className="michaela-trust-heading mirror-ornament">{copy.home.profileHeading}</h2>
          <p className="michaela-trust-profile-text">
            {copy.home.profile}
          </p>
        </div>
      </div>
    </section>
  );
}

export default TrustSection;
